import axios from 'axios';
import { VUE_APP_API_URL } from '@/utilities/constants.js';

export const state = initialState();

export const actions = {
  getItineraries: async ({ commit }, payload) => {
    try {
      const res = await axios.get(`${VUE_APP_API_URL}/itineraries`, {
        params: {
          ...payload
        }
      });

      commit('mutateItineraries', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getItinerariesNearMe: async ({ commit }, payload) => {
    try {
      const res = await axios.get(`${VUE_APP_API_URL}/itineraries`, {
        params: {
          ...payload
        }
      });

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  createItinerary: async (_, payload) => {
    try {
      const { projectId, ...body } = payload;

      const res = await axios.post(`${VUE_APP_API_URL}/itineraries`, body, {
        params: {
          projectId
        }
      });

      return res;
    } catch (err) {
      console.error(err);
      return err.response;
    }
  },

  getItineraryById: async ({ commit }, payload) => {
    try {
      const { itineraryId } = payload;

      const res = await axios.get(
        `${VUE_APP_API_URL}/itineraries/${itineraryId}`
      );
      commit('mutateItineraryById', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  updateItinerary: async (_, payload) => {
    try {
      const { itineraryId, ...theRest } = payload;
      const res = await axios.put(
        `${VUE_APP_API_URL}/itineraries/${itineraryId}`,
        {
          itinerary: { ...theRest }
        }
      );

      return res;
    } catch (err) {
      console.error(err);
      return err.response;
    }
  },

  deleteItinerary: async (_, payload) => {
    try {
      const { itineraryId } = payload;
      const res = await axios.delete(
        `${VUE_APP_API_URL}/itineraries/${itineraryId}`
      );
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  updateItineraryStatus: async (_, payload) => {
    try {
      const { itineraryId, status } = payload;

      const res = await axios.put(
        `${VUE_APP_API_URL}/itineraries/${itineraryId}/update-status`,
        null,
        {
          params: { status }
        }
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  addItineraryPOI: async (_, payload) => {
    try {
      const { itineraryId, ...theRest } = payload;

      const res = await axios.put(
        `${VUE_APP_API_URL}/itineraries/${itineraryId}/add-poi`,
        theRest
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  removeItineraryPOI: async (_, payload) => {
    try {
      const { itineraryId, poiId } = payload;

      const res = await axios.put(
        `${VUE_APP_API_URL}/itineraries/${itineraryId}/remove-poi`,
        poiId
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  updateItineraryPOI: async (_, payload) => {
    try {
      const { itineraryId, poiId, ...theRest } = payload;

      const res = await axios.put(
        `${VUE_APP_API_URL}/itineraries/${itineraryId}/update-poi`,
        poiId,
        theRest
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  bookmarkItinerary: async (_, payload) => {
    try {
      const { itineraryId, pinned } = payload;

      const res = await axios.put(
        `${VUE_APP_API_URL}/itineraries/${itineraryId}/bookmark`,
        { pinned: pinned }
      );
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  unbookmarkItinerary: async (_, payload) => {
    try {
      const { itineraryId } = payload;

      const res = await axios.delete(
        `${VUE_APP_API_URL}/itineraries/${itineraryId}/bookmark`
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  setItineraryBeingBuilt: ({ commit }, payload) => {
    commit('mutateItineraryBeingBuilt', payload);
    return;
  }
};

export const mutations = {
  mutateItineraries: (state, payload) => {
    state.itineraries = payload;
  },

  mutateItineraryById: (state, payload) => {
    state.itineraryById = payload;
  },

  mutateItineraryBeingBuilt: (state, payload) => {
    state.itineraryBeingBuilt = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    itineraries: {},
    itineraryById: {},
    itineraryBeingBuilt: {}
  };
}
